module.exports = __webpack_public_path__ + "static/media/bath_img.9a9a6999.png";